import { useDispatch, useSelector } from "react-redux";
import { updateFilter } from "../../actions";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import store from "store";
import Icon from "@identitybuilding/idb-react-iconlib";
import { Search } from "@identitybuilding/idb-react-iconlib/lib";
import { getEnvEndpoints } from "../../utils/functions";

const SearchFilter = ({ props, page, noLocation, loading, hadsearched }) => {
  const dispatch = useDispatch();
  let { lang, translate } = useSelector((state) => state.general);
  let { serviceFilter } = useSelector((state) => state.search);
  let [filters, setFilters] = useState(false);
  let [facilities, setFacilities] = useState([]);
  // let [searchFacilities, setSearchFacilities] = useState([])
  let path = useSelector((state) => state.general.search_path);
  let search = useSelector((state) => state.search);
  let categoryID = useSelector((state) => state.search.categoryID);
  const keyboard = store.get("vkb");

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let params = useQuery().get("service");
  let urlItems = "";
  if (params) {
    urlItems = params.split(",");
  }
  const env = getEnvEndpoints()

  const getFacilities = useCallback(
    async (test) => {
      await axios
        .get(
          `${env.REACT_APP_BASE_MEDIA_URL}/core/api/filters/?lang=${lang}`
        )
        .then((res) => {
          let new_facilities = [];
          for (let i = 0; i < res.data.facilities.length; i++) {
            let facility = res.data.facilities[i];
            let name = "";
            name = facility.name
            // facility[`name_${lang}`] ||
            // facility.name_nl ||
            // facility.name_fr ||
            // facility.name_de ||
            // facility.name_en;
            let new_item = {
              code: facility.id,
              icon: facility.icon,
              // facility.icon[`png_${lang}`] ||
              // facility.icon.png_nl ||
              // facility.icon.png_fr ||
              // facility.icon.png_de ||
              // facility.icon.png_en,
              name: name,
              active:
                // urlItems.includes(facility.id.toString()) ||
                // serviceFilter.includes(facility.id.toString()) ||
                test && test.includes(facility.id.toString()),
            };
            new_facilities.push(new_item);
          }
          setFacilities(new_facilities);

          // If the first item is not empty, dispatch it
          // if (urlItems.length > 0) {
          //   dispatch(updateFilter(urlItems));
          // }
        });
    },
    [dispatch, lang]
  );

  let copy_search_facilities = serviceFilter;
  // if (typeof serviceFilter !== "string") {
  //   for (let i = 0; i < serviceFilter.length; i++) {
  //     copy_search_facilities.push(Number(serviceFilter[i]));
  //   }
  // }
  useEffect(() => {
    getFacilities(serviceFilter);
  }, []);

  useEffect(() => {
    if (!page || page !== "results") {
      setTimeout(() => {
        setFilters(true);
      }, 500);
      setTimeout(() => {
        setFilters(false);
      }, 4000);
    }
  }, [page]);

  const checkBoxHandler = (index) => {
    // set facilities (in)active
    let copy = [...facilities];
    copy[index].active = !copy[index].active;
    setFacilities(copy);

    if (copy[index].active) {
      copy_search_facilities.push(copy[index].code.toString());
    } else {
      copy_search_facilities = copy_search_facilities.filter(
        (e) => e !== copy[index].code.toString()
      );
      // setSearchFacilities(copy_search_facilities);
    }
    dispatch(updateFilter(copy_search_facilities));
  };

  return (
    <div
      className={`searchOptions filter ${page}  ${filters ? "active" : ""}`}
      style={{ animation: "searchFilters 0.5s" }}
    >
      <span className="so_btn" onClick={() => !filters && setFilters(!filters)}>
        <span id="filterTitle" onClick={() => setFilters(!filters)}>
          {translate("search_filters")}{" "}
          {facilities.length > 0 &&
            serviceFilter.length + "/" + facilities.length}
          {filters && <Icon name="Close" />}
        </span>

        <div className={`filtersMainWrapper ${filters ? "active" : ""}`}>
          <div className={`filterWrapper`}>
            {/* Get the first 5 facilities */}
            {facilities.length > 0 &&
              facilities.slice(0, 5).map((facility, index) => (
                <div
                  title={facility.name}
                  className={`searchFilter ${facility.active ? "active" : ""}`}
                  key={index}
                  onClick={() => checkBoxHandler(index)}
                >
                  <div className="icon">
                    {facility.icon && (
                      <div className="svg">
                        <img
                          src={facility.icon}
                          alt={facility.name}
                          width="26px"
                          height="26px"
                          className="img_servicefilters"
                        />
                      </div>
                    )}
                  </div>
                  <span>{facility.name} </span>
                </div>
              ))}
          </div>
          <div className={`filterWrapper second`}>
            {/* Then, get the other set of 5 */}
            {facilities.length > 0 &&
              facilities.slice(5, 10).map((facility, index) => (
                // We do index + 5 because we start at the fifth item
                <div
                  title={facility.name}
                  className={`searchFilter ${facility.active ? "active" : ""}`}
                  key={index}
                  onClick={() => checkBoxHandler(index + 5)}
                >
                  <div className="icon">
                    {facility.icon && (
                      <div className="svg">
                        <img
                          src={facility.icon}
                          alt={facility.name}
                          width="26px"
                          height="26px"
                          className="img_servicefilters"
                        />
                      </div>
                    )}
                  </div>
                  <span>{facility.name} </span>
                </div>
              ))}
          </div>

          {search.location.length > 0 ? (
            !loading ? (
              <Link
                id="filterSearchButton"
                to={
                  Array.isArray(search.location[0]) && search.location[0].length > 0 &&
                  path(
                    search.location[0][0] && search.location[0][0].slug,
                    search.keyword_value,
                    1,
                    keyboard,
                    categoryID && categoryID,
                    serviceFilter
                  )
                }
                onClick={(e) => {
                  setFilters(false);
                  getFacilities(serviceFilter);
                }}
              >
                {translate("search_with_filters")}
              </Link>
            ) : (
              <div id="filterSearchButton" onClick={() => hadsearched(true)}>
                {translate("search_with_filters")}
              </div>
            )
          ) : (
            // <a
            //     id='filterSearchButton'
            //     href={search.location.length > 0 && path(search.location[0] && search.location[0].slug, search.keyword_value, 1, keyboard, categoryID && categoryID, serviceFilter)}
            //     onClick={(e) => setFilters(false)}
            // >
            //    {translate('search_with_filters')}
            //             </a>
            <span
              id="filterSearchButton"
              className="inactive"
              onClick={(e) => noLocation(e)}
            >
              {translate("search_with_filters")}
            </span>
          )}
        </div>
      </span>
    </div>
  );
};

export default SearchFilter;
